import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import SwitchList from 'components/commom/SwitchList';
import MailIcon from 'assets/images/Dashboard/mail-request.svg';
import CallIcon from 'assets/images/Dashboard/call-request.svg';
import AddressIcon from 'assets/images/Dashboard/location.svg';
import { getProviderDetailData } from 'store/providerDetail/providerDetailAction';
import ReusableTabs from 'components/commom/Tab';
import AboutTab from './AboutTab';
import moment from 'moment';
import ScheduleTab from './ScheduleTab';
import AppointmentTab from './AppointmentTab';
import { getUpdateStatusValue } from 'store/providerStatus/providerStatusAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import Shimmer from 'components/commom/Shimmer';
import { useDropzone } from 'react-dropzone';
import { uploadAction } from 'store/profileUpload/profileUploadAction';
import CommonModal from 'components/commom/Modal';
import EditBioIcon from 'assets/images/Dashboard/edit-bio.svg';
import UploadIcon from 'assets/images/camera.svg';
import EditIconProfie from 'assets/images/Dashboard/edit-profile-modal.svg';
import CloseIcon from 'assets/images/Dashboard/close-profile.svg';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import Download from 'assets/images/Dashboard/dowload.svg';
import ReusableButton from 'components/commom/Button';
import { updateProfileSectionData } from 'store/updateDoctorProfile/updateDoctorProfileAction';
import CommonToast from 'components/commom/CommonToast';

const DoctorDetail = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { showToast } = CommonToast();
  const [doctorDetailValue, setDoctorDetailValue] = useState();
  const [tab, setTab] = useState(1);
  const [profileModal, setProfileModal] = useState(false);
  const [formData, setFormData] = useState({
    profileUpload: '',
    profileUploadId: '',
    fullName: '',
    mobileNumber: '',
    email: '',
    address: '',
  });
  const [formDataDisable, setFormDataDisable] = useState({
    profileUpload: '',
    profileUploadId: '',
    fullName: '',
    address: '',
  });

  const providerDetailReducer = useSelector(
    (state) => state?.providerDetailReducer?.loading
  );

  const profileReducer = useSelector((state) => state?.UploadReducer?.loading);

  const updateProfileReducer = useSelector(
    (state) => state?.updateProfileSectionDataReducer?.loading
  );

  const providerId = useSelector(
    (state) => state?.basicDetailsValueReducer?.providerId
  );

  useEffect(() => {
    getProviderDetail();
  }, []);

  const getProviderDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setDoctorDetailValue(res?.data);
        handleSuccess(res);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProviderDetailData(external, providerId));
  };

  const handleSuccess = (response) => {
    setFormData((prevState) => ({
      ...prevState,
      profileUpload: response?.data?.provider_image,
      fullName: response?.data?.provider_name,
      mobileNumber: `${response?.data?.provider_phone}`,
      email: response?.data?.provider_email,
      address: response?.data?.address?.address_line1,
    }));
    setFormDataDisable((prevState) => ({
      ...prevState,
      profileUpload: response?.data?.provider_image,
      fullName: response?.data?.provider_name,
      address: response?.data?.address?.address_line1,
    }));
  };

  const handleStatusChange = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        getProviderDetail();
        showToast(res?.message, 'success');
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {};
    dispatch(getUpdateStatusValue(external, doctorDetailValue?.id, body));
  };
  const tabData = [
    { label: intl.formatMessage({ id: 'About' }) },
    { label: intl.formatMessage({ id: 'Schedule' }) },
    { label: intl.formatMessage({ id: 'Appointment History' }) },
  ];
  const handleTabChange = (val) => {
    setTab(val);
  };

  const handleProfileModal = () => {
    setProfileModal(true);
  };

  const handleCloseProfile = () => {
    setProfileModal(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: '.jpg, .png, .jpeg',
    onDrop: (acceptedFiles) => {
      let formData = new FormData();
      acceptedFiles.forEach((file) => {
        formData.append('filePath', file);
      });
      const external = {
        run: true,
        handleFunction: (res) => {
          setFormData((prev) => ({
            ...prev,
            profileUpload: res?.data?.[0]?.filePath,
            profileUploadId: res?.data?.[0]?.id,
          }));
          showToast(res?.message, 'success');
        },
        error: true,
        handleErrorFunction: (res) => showToast(res?.message, 'error'),
      };
      dispatch(uploadAction(formData, external));
    },
  });

  const handleInputChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveProfile = () => {
    const external = {
      providerId,
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setProfileModal(false);
        getProviderDetail();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      personal_details: {
        full_name: formData?.fullName,
        address: {
          address_line1: formData?.address,
        },
      },
    };
    if (formData?.profileUploadId === '') {
      delete body['profile_image_id'];
    } else {
      body[' profile_image_id'] = +formData?.profileUploadId;
    }
    dispatch(updateProfileSectionData(external, body));
  };

  const getUpdateValue = (value) => {
    if (value) {
      getProviderDetail();
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Providers
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Provider Details
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col md={8} className="p-0">
              <div className="flex">
                <div>
                  <Image
                    src={ArrowDetail}
                    alt="icon"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                  Provider Details
                </div>
              </div>
            </Col>
            <Col md={4} className="p-0 flex justify-end">
              <Stack
                direction="horizontal"
                gap={2}
                className="flex items-start cursor-pointer ..."
                onClick={() => handleProfileModal()}
              >
                <Image src={EditBioIcon} alt="icon" />
                <div className="fs-16 lh-20 fc-292D32 family_outfit_semiBold_600">
                  <FormattedMessage id="Edit Profile" />
                </div>
              </Stack>
            </Col>
            <Col md={12} lg={6} className="p-0">
              <Stack
                direction="horizontal"
                gap={3}
                className="flex items-start pt-8"
              >
                {providerDetailReducer ? (
                  <Shimmer width="100px" height="100px" borderRadius="50%" />
                ) : (
                  <Image
                    src={
                      doctorDetailValue?.provider_image !== ''
                        ? doctorDetailValue?.provider_image
                        : ImageNull
                    }
                    alt="Uploaded profile"
                    className={
                      doctorDetailValue?.provider_image ? 'uploadPhoto' : ''
                    }
                  />
                )}
                <div className="p-0 m-0">
                  <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500">
                    {providerDetailReducer ? (
                      <Shimmer width="250px" height="20px" />
                    ) : (
                      <p className="p-0 m-0 fs-18 family_outfit_medium_500 lh-2268 fc-202224">
                        {doctorDetailValue?.provider_name}
                      </p>
                    )}
                  </div>
                  <div className="fs-16 lh-201 fc-998A7B family_outfit_regular_400 break-all ...">
                    {providerDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'12px'} />
                    ) : (
                      <p className="pt-12 m-0 fs-16 lh-201 family_outfit_regular_400 fc-A4AAB2">
                        {doctorDetailValue?.provider_id}
                      </p>
                    )}
                  </div>
                  <div className="p-0 m-0">
                    <Stack
                      direction="horizontal"
                      gap={4}
                      className="items-center pt-12"
                    >
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        {providerDetailReducer ? (
                          <Shimmer width="250px" height="20px" />
                        ) : (
                          <>
                            <Image src={CallIcon} alt="icon" />
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400">
                              {doctorDetailValue?.provider_phone}
                            </div>
                          </>
                        )}
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        {providerDetailReducer ? (
                          <Shimmer width="250px" height="20px" />
                        ) : (
                          <>
                            <Image src={MailIcon} alt="icon" />
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 break-all ...">
                              {doctorDetailValue?.provider_email}
                            </div>
                          </>
                        )}
                      </Stack>
                    </Stack>
                  </div>
                </div>
              </Stack>
              {doctorDetailValue?.medical_licence !== null &&
                doctorDetailValue?.licence_expiry_date !== null && (
                  <div className="pt-24">
                    <Row className="p-0 m-0">
                      <Col sm={7} className="p-0">
                        <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                          Medical License
                        </div>
                        <div className="pt-8 flex pr-20">
                          <a
                            href={doctorDetailValue?.medical_licence || '#'}
                            download={doctorDetailValue?.medical_licence}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="truncate flex-1 underline fs-16 fc-5B88E9 family_outfit_regular_400"
                          >
                            {providerDetailReducer ? (
                              <Shimmer
                                width="150px"
                                height="20px"
                                marginTop={'8px'}
                              />
                            ) : (
                              doctorDetailValue?.medical_licence && (
                                <>
                                  {doctorDetailValue?.medical_licence
                                    .split('/')
                                    .pop()}
                                </>
                              )
                            )}
                          </a>
                          <span>
                            <a
                              href={doctorDetailValue?.medical_licence || '#'}
                              download={doctorDetailValue?.medical_licence}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Image
                                src={Download}
                                alt="icon"
                                className="pl-2"
                              />
                            </a>
                          </span>
                        </div>
                      </Col>

                      <Col sm={4} className="p-0">
                        <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                          Licence Expire Date
                        </div>
                        {providerDetailReducer ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                            {moment(
                              doctorDetailValue?.licence_expiry_date
                            ).format('DD MMM YYYY')}
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                )}
            </Col>
            <Col md={12} lg={6} className="p-0">
              <div className="pt-20 lg:pt-10">
                <Row className="m-0 p-0">
                  <Col sm={4} className="p-0">
                    <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                      Title
                    </div>

                    <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                      {providerDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        doctorDetailValue?.title?.name
                      )}
                    </div>
                  </Col>
                  <Col sm={4} className="p-0">
                    <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                      Provider Type
                    </div>
                    <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                      {providerDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        doctorDetailValue?.provider_type?.name
                      )}
                    </div>
                  </Col>

                  <Col sm={4} className="p-0">
                    <div>
                      <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                        Active since:
                      </div>
                      {providerDetailReducer ? (
                        <Shimmer
                          width="150px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                          {moment(doctorDetailValue?.date_joined).format(
                            'DD MMM YYYY'
                          )}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="pt-20">
                <Row className="m-0 p-0">
                  <Col sm={4} className="p-0">
                    <Stack
                      direction="horizontal"
                      gap={1}
                      className="items-center"
                    >
                      <div>
                        <Image src={AddressIcon} alt="icon" />
                      </div>
                      <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                        Address
                      </div>
                    </Stack>
                    <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                      {providerDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        doctorDetailValue?.address?.address_line1
                      )}
                    </div>
                  </Col>
                  <Col sm={4} className="p-0">
                    <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                      Country
                    </div>

                    <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                      {providerDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        doctorDetailValue?.address?.country?.name
                      )}
                    </div>
                  </Col>
                  <Col sm={4} className="p-0">
                    <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                      State
                    </div>
                    <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                      {providerDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        doctorDetailValue?.address?.state?.name
                      )}
                    </div>
                  </Col>

                  <Col sm={4} className="p-0">
                    <div className="pt-20">
                      <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                        City
                      </div>
                      {providerDetailReducer ? (
                        <Shimmer
                          width="150px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                          {doctorDetailValue?.address?.city?.name}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col sm={4} className="p-0">
                    <div className="pt-20">
                      <div className="fs-14 lh-176 family_outfit_regular_400 fc-A4AAB2 ">
                        ZIP Code
                      </div>
                      {providerDetailReducer ? (
                        <Shimmer
                          width="150px"
                          height="20px"
                          marginTop={'4px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 pt-04">
                          {doctorDetailValue?.address?.zip_code}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="m-0 p-0">
            <Col md={12} lg={8} className="p-0">
              <div className="pt-24">
                <ReusableTabs
                  tabs={tabData}
                  defaultTab={tab}
                  currentTab={(val) => handleTabChange(val)}
                  background={'#0054F61A'}
                  color={'#0054F6'}
                  tabColor={'#A2A2A2'}
                  completeColor={'#FFFFFF'}
                  boxShadow={'0px 3px 16px 0px #00000014'}
                />
              </div>
            </Col>
          </Row>
          {tab === 1 && (
            <AboutTab getUpdateValue={(val) => getUpdateValue(val)} />
          )}
          {tab === 2 && <ScheduleTab />}
          {tab === 3 && <AppointmentTab />}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'680px'}
        modalActive={profileModal}
        innerContent={
          <div>
            <Row>
              <Col className="p-0">
                <div className="flex justify-between">
                  <div className="fs-24 lh-3024 fc-292D32 family_outfit_semiBold_600">
                    <FormattedMessage id="Edit profile" />
                  </div>
                  <div>
                    <Image
                      src={CloseIcon}
                      alt="icon"
                      className="cursor-pointer ..."
                      onClick={() => handleCloseProfile()}
                    />
                  </div>
                </div>
              </Col>
              <Col sm={12} className="m-0 p-0">
                <div className="d-flex justify-center align-items-center pt-16">
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <p>Drop the files here ...</p>
                    ) : (
                      <>
                        {formData?.profileUpload !== '' ? (
                          profileReducer ? (
                            <Shimmer
                              width="88px"
                              height="88px"
                              borderRadius="50%"
                            />
                          ) : (
                            <div className="uploadPhoto">
                              <Image
                                src={formData?.profileUpload}
                                alt="Uploaded profile"
                                className="uploadPhoto"
                              />
                            </div>
                          )
                        ) : (
                          <div className="uploadPhoto">
                            <div>
                              <Image src={UploadIcon} />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {!isDragActive && (
                      <Image
                        src={EditIconProfie}
                        alt="edit"
                        className="align-self-center editBtn d-flex justify-content-center"
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <LabelWithInput
                  label="Full Name"
                  placeholder="full Name"
                  name="fullName"
                  type="text"
                  value={formData?.fullName}
                  onChange={(e) => handleInputChange(e, 'providerName')}
                />
              </Col>
              <Col md={6} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Mobile number"
                    placeholder="Mobile number"
                    name="mobileNumber"
                    type="text"
                    value={formData?.mobileNumber}
                    onChange={(e) => handleInputChange(e, 'mobileNumber')}
                    disabled={'true'}
                  />
                </div>
              </Col>
              <Col md={6} className="modal-size">
                <div className="pt-16">
                  <LabelWithInput
                    label="Email"
                    placeholder="Email"
                    name="email"
                    type="text"
                    value={formData?.email}
                    onChange={(e) => handleInputChange(e, 'email')}
                    disabled={'true'}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Address"
                    placeholder="Address"
                    name="address"
                    type="text"
                    value={formData?.address}
                    onChange={(e) => handleInputChange(e, 'address')}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-40 flex justify-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="44px"
                    bgColor=" #375241"
                    brColor="transparent"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !updateProfileReducer && handleSaveProfile();
                    }}
                    loading={updateProfileReducer}
                    disabled={
                      formData?.fullName === formDataDisable?.fullName &&
                      formData?.address === formDataDisable?.address &&
                      formData?.profileUpload === formDataDisable?.profileUpload
                    }
                    disabledBgColor="lightgray"
                    disabledCursor="not-allowed"
                  >
                    <FormattedMessage id="Save" />
                  </ReusableButton>
                </div>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default DoctorDetail;
